export const POST_LOGIN_PATH = '/homeview'

export function resolvePostLoginRedirect(redirect) {
  const path = Array.isArray(redirect) ? redirect[0] : redirect
  if (!path || path === '/homeview' || String(path).startsWith('/homeview')) {
    return POST_LOGIN_PATH
  }
  return path
}
